<script setup lang="ts">
import type { NuxtError } from '#app'
import { mdiAlertCircleOutline } from '@mdi/js'

defineProps({
  error: Object as () => NuxtError,
})

const { t } = useI18n({ useScope: 'local' })
</script>

<template>
  <div class="d-flex flex-column align-center justify-center text-center full-page" fluid>
    <v-icon :icon="mdiAlertCircleOutline" color="primary" size="120" class="icon-animation" />

    <h1 class="display-2 text-primary">
      404
    </h1>

    <p class="text-subtitle-1 my-4">
      {{ t('notFound') }}
    </p>

    <v-btn color="primary" variant="outlined" to="/" class="mt-5">
      {{ t('back') }}
    </v-btn>
  </div>
</template>

<style scoped>
.full-page {
  height: 100vh;
  background-color: #f5f5f5;
}

.icon-animation {
  animation: iconBounce 1.5s ease-in-out infinite;
}

@keyframes iconBounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-15px);
  }
  60% {
    transform: translateY(-8px);
  }
}
</style>

<i18n lang="yaml">
  de:
    notFound: Huch! Die gesuchte Seite wurde nicht gefunden.
    back: Zurück zur Startseite
  en:
    notFound: Oops! The page you're looking for can't be found.
    back: Go Back to Home
</i18n>
